// @ts-nocheck
import { Column } from 'react-table'
import { TitleCell } from './TitleCell'
import { UserCustomHeader } from './CustomHeader'
import moment from 'moment';
import { ActionCell } from './ActionCell';
import { TextCell } from './TextCell';
import { useDispatch } from 'react-redux';

import { setOpenDocumentUploadModal } from "../../../../redux/features/invoice/invoiceSlice";


const invoiceListColumns: ReadonlyArray<Column<User>> = [
//    {
//   Header: (props) => (
//     <UserCustomHeader
//       tableProps={props}
//       title="Invoice Number"
//       className="min-w-50px"
//     />
//   ),
//   id: 'invoice_number',
//   Cell: ({ row }) => {
//     const dispatch = useDispatch();
//     const rowData = row.original;
//     const invoiceNumber = rowData?.invoice_number;
//     const isUploaded = rowData?.is_all_documents_uploaded;
//     const supplierCountry = rowData?.supplier?.country_of_manufacturer;

//     // All possible document display names
//     const documentDisplayNames: { [key: string]: string } = {
//       invoice_pdf: 'Fattura',
//       packing_list: 'Packing List',
//       atr: 'ATR',
//       cmr: 'CMR',
//       bill_of_lading: 'Bill of Lading'
//     };

//     // Define required documents based on country_of_manufacturer
//     let requiredDocuments: string[] = [];
//     if (supplierCountry === 'tipo-1') {
//       requiredDocuments = ['invoice_pdf']; // Only Fattura
//     } else if (supplierCountry === 'tipo-2' || supplierCountry === 'tipo-3') {
//       requiredDocuments = ['invoice_pdf', 'packing_list', 'atr', 'cmr', 'bill_of_lading'];
//     }

//     // Get missing docs from backend (if any)
//     const missingDocuments = rowData?.missing_documents || [];

//     // Filter missingDocuments to only include those required for that country
//     const filteredMissingDocuments = missingDocuments.filter(doc =>
//       requiredDocuments.includes(doc)
//     );

//     // If none of the required documents are missing, mark as complete
//     const isComplete = filteredMissingDocuments.length === 0;

//     const displayMissingDocuments = filteredMissingDocuments.map(doc =>
//       documentDisplayNames[doc] || doc
//     );

//     return (
//       <>
//         {isComplete ? (
//           <div className="d-flex align-items-center gap-3">
//             <span className="fw-semibold text-dark">{invoiceNumber}</span>
//             <span className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill fw-medium border bg-success-subtle text-success border-success">
//               <i className="bi bi-check-circle-fill text-success"></i>
//               Completo
//             </span>
//           </div>
//         ) : (
//           <div>
//             <div className="d-flex align-items-start gap-3">
//               <div className="d-flex align-items-center gap-2 flex-shrink-0">
//                 <span className="fw-semibold text-dark">{invoiceNumber}</span>
//                 <span className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill fw-medium border bg-danger text-white border-danger">
//                   <i className="bi bi-exclamation-triangle-fill"></i>
//                   Document missing
//                 </span>
//               </div>
//             </div>

//             <div className="bg-danger-subtle border border-danger rounded p-2 mt-2">
//               <div className="d-flex align-items-center gap-2">
//                 <i className="bi bi-exclamation-triangle-fill text-danger"></i>
//                 <span className="text-danger fw-medium" style={{ fontSize: '0.85rem' }}>
//                   Document missing: {displayMissingDocuments.join(', ')}
//                 </span>
//               </div>
//               <div className="text-muted small mt-1">
//                 The invoice has not yet been submitted.
//               </div>

//               <div className="d-flex justify-content-end mt-2">
//                 <button
//                   className="btn btn-primary text-white fw-semibold"
//                   style={{
//                     fontSize: '0.8rem',
//                     padding: '0.25rem 0.75rem',
//                     borderRadius: '0.25rem',
//                   }}
//                   onClick={() => {
//                     const timestamp = new Date('2025-10-20T14:32:00+05:30').toISOString();
//                     dispatch(setOpenDocumentUploadModal({
//                       invoiceNumber: rowData?.invoice_number,
//                       isViewMode: false,
//                       shipmentMethod: "truck",
//                       timestamp: timestamp,
//                     }));
//                   }}
//                 >
//                   Upload Now
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </>
//     );
//   },
// },

{
  Header: (props) => (
    <UserCustomHeader
      tableProps={props}
      title="Invoice Number"
      className="min-w-50px"
    />
  ),
  id: 'invoice_number',
  Cell: ({ row }) => {
    const dispatch = useDispatch();
    const rowData = row.original;
    const invoiceNumber = rowData?.invoice_number;
    const isUploaded = rowData?.is_all_documents_uploaded;
    const supplierCountry = rowData?.supplier?.country_of_manufacturer;

    // Document display names
    const documentDisplayNames: { [key: string]: string } = {
      invoice_pdf: 'Fattura',
      packing_list: 'Packing List',
      atr: 'ATR',
      cmr: 'CMR',
      bill_of_lading: 'Bill of Lading'
    };

    // Determine which documents to show based on country
    let displayMissingDocuments: string[] = [];

    if (!isUploaded) {
      if (supplierCountry === 'tipo-1') {
        // Tipo-1 → Only invoice required
        displayMissingDocuments = [documentDisplayNames.invoice_pdf];
      } else if (supplierCountry === 'tipo-2' || supplierCountry === 'tipo-3') {
        // Tipo-2 or Tipo-3 → All docs required
        displayMissingDocuments = Object.values(documentDisplayNames);
      }
    }

    return (
      <>
        {isUploaded ? (
          <div className="d-flex align-items-center gap-3">
            <span className="fw-semibold text-dark">{invoiceNumber}</span>
            <span className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill fw-medium border bg-success-subtle text-success border-success">
              <i className="bi bi-check-circle-fill text-success"></i>
              Completo
            </span>
          </div>
        ) : (
          <div>
            <div className="d-flex align-items-start gap-3">
              <div className="d-flex align-items-center gap-2 flex-shrink-0">
                <span className="fw-semibold text-dark">{invoiceNumber}</span>
                <span className="d-inline-flex align-items-center gap-2 px-3 py-1 rounded-pill fw-medium border bg-danger text-white border-danger">
                  <i className="bi bi-exclamation-triangle-fill"></i>
                  Document missing
                </span>
              </div>
            </div>

            <div className="bg-danger-subtle border border-danger rounded p-2 mt-2">
              <div className="d-flex align-items-center gap-2">
                <i className="bi bi-exclamation-triangle-fill text-danger"></i>
                <span className="text-danger fw-medium" style={{ fontSize: '0.85rem' }}>
                  Document missing: {displayMissingDocuments.join(', ')}
                </span>
              </div>
              <div className="text-muted small mt-1">
                The invoice has not yet been submitted.
              </div>

              <div className="d-flex justify-content-end mt-2">
                <button
                  className="btn btn-primary text-white fw-semibold"
                  style={{
                    fontSize: '0.8rem',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '0.25rem',
                  }}
                  onClick={() => {
                    const timestamp = new Date('2025-10-20T14:32:00+05:30').toISOString();
                    dispatch(setOpenDocumentUploadModal({
                      invoiceNumber: rowData?.invoice_number,
                      isViewMode: false,
                      shipmentMethod: "truck",
                      timestamp: timestamp,
                    }));
                  }}
                >
                  Upload Now
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  },
},

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Invoice date' className='min-w-50px' />
  //   ),
  //   id: 'invoice_date',
  //   Cell: ({ ...props }) => {
  //     const rawDate = props.data[props.row.index]?.invoice_date;
  //     const formattedDate = rawDate ? moment(rawDate).format("YYYY/MM/DD") : "-";
  //     return <TitleCell userObj={formattedDate} />;
  //   },
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Order Number' className='min-w-50px' />
  //   ),
  //   id: 'order_number',
  //   Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.order_number} />,
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Article Code' className='min-w-50px' />
  //   ),
  //   id: 'article_code',
  //   Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.article_code} />,
  // },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Total Invoiced' className='min-w-50px' />
    ),
    id: 'total_invoiced',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.total_invoiced} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Unique Article count' className='min-w-50px' />
    ),
    id: 'item_count',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.item_count} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Total Quantity' className='min-w-50px' />
    ),
    id: 'quantity',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.total_quantity} />,
  },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Price' className='min-w-50px' />
  //   ),
  //   id: 'price',
  //   Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.price} />,
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Currency' className='min-w-50px' />
  //   ),
  //   id: 'currency',
  //   Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.currency} />,
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Description' className='min-w-50px' />
  //   ),
  //   id: 'description',
  //   Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.description} />,
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Expected Deliver Date' className='min-w-50px' />
  //   ),
  //   id: 'expected_delivery_date',
  //   Cell: ({ ...props }) => {
  //     const rawDate = props.data[props.row.index]?.expected_delivery_date;
  //     const formattedDate = rawDate ? moment(rawDate).format("YYYY/MM/DD") : "-";
  //     return <TitleCell userObj={formattedDate} />;
  //   },
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Supplier Code' className='min-w-50px' />
  //   ),
  //   id: 'supplier_code',
  //   Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.supplier_code} />,
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Production lot' className='min-w-50px' />
  //   ),
  //   id: 'production_lot',
  //   Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.production_lot} />,
  // },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Processed' className='min-w-50px' />
  //   ),
  //   id: 'processed',
  //   Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.processed} />,
  // }, {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Insertion Date' className='min-w-50px' />
  //   ),
  //   id: 'insertion_date',
  //   Cell: ({ ...props }) => {
  //     const rawDate = props.data[props.row.index]?.insertion_date;
  //     const formattedDate = rawDate ? moment(rawDate).format("YYYY/MM/DD") : "-";
  //     return <TitleCell userObj={formattedDate} />;
  //   },
  // },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Last Update' className='min-w-50px' />
  //   ),
  //   id: 'updatedAt',
  //   Cell: ({ ...props }) => <TitleCell userObj={moment(props.data[props.row.index]?.updatedAt).format("YYYY-MM-DD")} />,
  // },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Action' className='min-w-75px' />
    ),
    id: 'action',
    Cell: ({ ...props }) => <ActionCell user={props.data[props.row.index]} />,
  },
]

export { invoiceListColumns }
